<template>
  <div>
    <div class="loading-container" v-if="loadingContent">
      <a-spin tip="Loading..." />
    </div>

    <a-form-model :model="post" :label-col="labelCol" :wrapper-col="wrapperCol" v-else>
      <a-row>
        <a-col span="2" offset="4">
          <router-link :to="{name: 'PostsList'}">
            <a-icon type="left" />Go Back
          </router-link>
        </a-col>
        <a-col span="1" offset="9">
          <a-button @click="saveChanges()">Save</a-button>
        </a-col>
        <a-col span="2">
          <a-button
            type="primary"
            style="margin-left: 1em"
            v-show="post.publishDate == null"
            @click="saveChanges(true)"
          >Publish</a-button>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            v-show="post.publishDate != null"
            @click="unpublishPost()"
          >Unpublish</a-button>
        </a-col>
      </a-row>

      <a-form-model-item label="Title">
        <a-input v-model="post.title" />
      </a-form-model-item>

      <a-form-model-item label="Game">
        <a-select v-model="post.game" placeholder="Select the game of this post">
          <a-select-option v-for="game in games" :key="game.id" :value="game.id">{{game.name}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="Picture">
        <a-upload :remove="handleRemove" :multiple="false" :before-upload="beforeUpload">
          <a-button :disabled="postMainImage != null">
            <a-icon type="upload" />Select File
          </a-button>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="Content">
        <vue-editor
          id="editor"
          useCustomImageHandler
          @image-added="handleImageAdded"
          v-model="post.content"
        ></vue-editor>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import firebase from "@/configs/firebase-setup";

const db = firebase.firestore();
const storage = firebase.storage().ref();

export default {
  props: ["id"],
  data() {
    return {
      loadingContent: false,
      postMainImage: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      post: {
        id: "",
        title: "",
        game: "",
        content: "",
        isPublished: false
      },
      games: [
        { id: 1, name: "STAR CHASER" },
        { id: 2, name: "Flamy's Light" }
      ]
    };
  },

  created() {
    this.getPostData();
  },

  methods: {
    handleRemove(file) {
      this.postMainImage = null;
    },
    beforeUpload(file) {
      this.postMainImage = file;
      return false;
    },
    async saveChanges(isPublished = false) {
      try {
        this.loadingContent = true;
        // save content
        if (isPublished && this.post.publishDate == null) {
          this.post.publishDate = new Date();
        }

        const result = await db.doc(`posts/${this.id}`).update(this.post);

        // save picture
        if (this.postMainImage != null) {
          await storage
            .child(`images/posts/${this.id}/${this.id}`)
            .put(this.postMainImage);
        }

        this.loadingContent = false;
      } catch (error) {
        console.log(error);
        this.loadingContent = false;
      }
    },
    async getPostData() {
      try {
        this.loadingContent = true;
        const doc = await db.doc(`posts/${this.id}`).get();
        this.post = doc.data();
        this.loadingContent = false;
      } catch (error) {
        console.log(error);
        this.loadingContent = true;
      }
    },

    async unpublishPost() {
      try {
        this.loadingContent = true;
        this.post.publishDate = null;
        const result = await db.doc(`posts/${this.id}`).update(this.post);
        this.loadingContent = false;
      } catch (error) {
        this.loadingContent = false;
        console.log(error);
      }
    },
    handleUploadChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        console.log(info);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },

    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      storage
        .child(`images/posts/${this.id}/${file.name}`)
        .put(file)
        .then(async snapshot => {
          const imgUrl = await snapshot.ref.getDownloadURL();
          Editor.insertEmbed(cursorLocation, "image", imgUrl);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  components: {
    VueEditor
  }
};
</script>

<style scoped>
.loading-container {
  text-align: center;
  /* background: rgba(0, 0, 0, 0.05); */
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
</style>